module.exports = __webpack_public_path__ + "img/img_auto-w.a9494bf7.svg";